import * as React from 'react'
import styled from 'styled-components'

import * as api from '@owl-nest/api-client/latest'
import { styles as S, RoleTag, Link, COLORS } from '@ulule/owl-kit-components/next'
import * as model from '@owl-nest/models'

type UserProps = {
  user: api.PublicUser
  tag?: { backgroundColor?: model.user.RoleTagBackgroundColor; label: string }
}

export function User({ user, tag }: UserProps): React.ReactElement<UserProps> {
  return (
    <Creator href={user.absolute_url}>
      <S.image.Avatar type="small" src={model.user.avatar(user, '180x180')} />
      <CreatorName>{model.user.username(user)}</CreatorName>
      {tag && <RoleTag backgroundColor={tag.backgroundColor}>{tag.label}</RoleTag>}
    </Creator>
  )
}

const Creator = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  ${S.image.Avatar} {
    margin-right: 5px;
    flex: none;
  }
`
const CreatorName = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: ${COLORS.PRIMARY_GREY_900};
  display: inline-block;
  margin-right: 5px;
  flex: none;
`
